import { makeStyles } from "@material-ui/core/styles";
const useShareModalStyles = (isRtl: boolean) =>
  makeStyles({
    modal: {
      margin: "auto",
      background: "white",
      height: "100vh",
      width: "770px",
    },
    body: {
      padding: "24px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "white",
      "& button": {
        textTransform: "unset",
      },
      "& .title": {
        display: "flex",
        gap: "16px",
        marginBottom: "20px",
        alignItems: "center",
        direction: isRtl ? "rtl" : "ltr",
        "& .icon": {
          display: "flex",
          justifyCotent: "center",
          marginInlineEnd: "16px",
          "& svg": {
            width: "25px",
            height: "25px",
            color: "white",
            margin: "auto",
          },
          "& .bg": {
            background: "rgb(0,100,216)",
            borderRadius: "32px",
            width: "48px",
            display: "flex",
            height: "48px",
          },
        },
        "& .titleText": {
          color: "#4C5157",
          fontFamily: "Dubai",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "20px",
          flexGrow: 1,
        },
        "& .closeIcon": {
          background: "#f1f1f2",
          color: "#8d8d8d",
          borderRadius: "50px",
          display: "flex",
          padding: "10px",
          cursor: "pointer",
          marginInlineStart: "16px",
        },
      },
      "& .separator": {
        width: "100%",
        border: "1px solid #979797",
        opacity: "0.16",
      },
      "& .content": {
        height: "100%",
        padding: "32px 0",
        overflow: "hidden",
        "& .notShared": {
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          gap: "57px",
          "& svg": {
            width: "87px",
            height: "87px",
          },
          "& span": {
            fontFamily: "'Dubai'",
            fontSize: "18px",
            textAlign: "center",
            color: "#4C5157",
          },
        },
      },
      "& .actions": {
        display: "flex",
        gap: "12px",
        marginTop: "20px",
        alignItems: "center",
        alignContents: "center",
        "& .enableShareBtn": {
          flexGrow: 1,
          color: "rgb(0,100,216)",

          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "17.5068px",
          "& .MuiButton-label": {
            justifyContent: "start",
          },
        },
        "& .cancelBtn": {
          background: "#E7E7E7",
          fontFamily: "'Dubai'",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: "12px",
          borderRadius: "20px",
          padding: "10px 40px",
          color: "#4C5157",
        },
        "& .shareBtn": {
          background: "rgb(0,100,216)",
          fontFamily: "'Dubai'",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: "12px",
          borderRadius: "20px",
          padding: "10px 40px",
          color: "white",
        },
      },
    },
  });

const useUsersSelectionItemStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  itemInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  itemText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#4C5157",
  },
  imagePlaceholder: {
    width: "32px",
    minWidth: "32px",
    height: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Dubai",
    textTransform: "uppercase",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    backgroundColor: "#7E879142",
    borderRadius: "50%",
  },
  addIcon: {
    color: "rgb(0,100,216)",
    fontFamily: "'Dubai'",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
  },
  removeIcon: {
    color: "rgba(76, 81, 87, 0.5)",
    cursor: "pointer",
    fontFamily: "'Dubai'",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
  },
});

const useUsersSelectionTableStyles = (isRtl: boolean) =>
  makeStyles({
    container: {
      display: "flex",
      borderRadius: "6px",
      minwidth: "542px",
      height: "100%",
      direction: isRtl ? "rtl" : "ltr",
      margin: "0",
    },
    column: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      border: "1px solid #D1D5DB",
      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
    },
    verticalSeparator: {
      height: "100%",
      width: "25px",
    },
    columnTitle: {
      fontFamily: "'Dubai'",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "17px",
      color: "#4C5157",
      marginBottom: "8px",
    },
    searchIcon: {
      color: "#7E8791",
      // marginLeft: `0.36em`,
      // marginRight: '0.33em',
      borderRadius: "50%",
    },
    searchField: {
      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
      height: "38px",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      paddingRight: "5px",
      borderColor: "#D1D5DB",
      color: "#7E8791;",
      maxWidth: "147px",
    },
    horizontalSeparator: {
      border: "1px solid #D1D5DB99",
      width: "100%",
    },
    columnHeader: {
      padding: "11px 16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      alignContent: "center",
      borderBottom: "1px solid #D1D5DB",
    },
    columnContent: {
      padding: "11px 16px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflowY: "auto",
    },
    doAllBtn: {
      background: "rgba(238, 238, 243, 0.5)",
      borderRadius: "40px",
      fontFamily: "'Dubai'",
      fontWeight: 500,
      fontSize: "12px",
      textTransform: "uppercase",
      color: "rgb(0,100,216)",
      margin: "7px auto ",
      width: "fit-content",
    },
    emptyPlaceHolder: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      gap: "17px",
      fontFamily: "'Dubai'",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      textAlign: "center",
      color: "#4C5157",
      alignItems: "center",
      margin: "auto",
      "& svg": {
        width: "30px",
        height: "30px",
      },
    },
  });

export {
  useShareModalStyles,
  useUsersSelectionItemStyles,
  useUsersSelectionTableStyles,
};
